import React, { useRef, useState } from 'react';
import TextArea from 'devextreme-react/text-area';
import { Validator, RequiredRule } from 'devextreme-react/validator';
interface MultilineTextBoxProps {
    id?: string;
    value?: string;
    readOnly?: boolean;
    onChange: (value: string) => void;
    label?: string;
    helperText?: string;
    required?: boolean;
    children?: React.ReactNode;
    validator?: React.ReactNode;
    width?: string;
    height?: string;
    maxLength?: number;
    placeholder?: string;
}

export const MultilineTextBox: React.FC<MultilineTextBoxProps> = ({
    id,
    value,
    readOnly = false,
    onChange,
    label,
    helperText,
    required = false,
    children,
    validator,
    width = 'auto',
    height = 'auto',
    maxLength,
    placeholder,
}) => {
    const [errorMessage, setErrorMessage] = useState('');
    const validatorRef = useRef<any>(null);

    const handleValueChanged = (e: any) => {
        onChange(e.value);
    };

    // Example: on focus out, validate and update error state
    const handleFocus = () => {
        if (validatorRef.current) {
            const result = validatorRef.current.instance.validate();
            if (!result.isValid) {
                // Assuming the first broken rule's message is the error message:
                setErrorMessage(result.brokenRules[0]?.message || '');
            } else {
                setErrorMessage('');
            }
        }
    };

    return (
        <div
            className='textarea-container'
            style={{ width: width }}
        >
            {label && <label className={`textarea-label ${errorMessage ? 'error' : ''}`}>{label}</label>}
            <div
                className='textarea-wrapper'
                style={{ position: 'relative' }}
            >
                <TextArea
                    id={id}
                    value={value}
                    valueChangeEvent='change'
                    readOnly={readOnly}
                    onValueChanged={handleValueChanged}
                    onFocusIn={handleFocus}
                    onFocusOut={handleFocus}
                    className={`textarea-input ${errorMessage ? 'error' : ''}`}
                    width={width}
                    height={height}
                    maxLength={maxLength}
                    placeholder={placeholder}
                >
                    <Validator ref={validatorRef}>
                        {required && <RequiredRule message='This field is required' />}
                        {validator}
                    </Validator>
                </TextArea>
            </div>
            {/* Show helper text only if there is no error */}
            {errorMessage ? (
                <div className='textarea-error'>{errorMessage}</div>
            ) : (
                helperText && <div className='textarea-helper'>{helperText}</div>
            )}
            {children && <div className='textarea-children'>{children}</div>}
        </div>
    );
};
